import {HttpErrorResponse} from '@angular/common/http';

/**
 * Extracts the message sent by the backend (Cloud Endpoints format: `{error: {code, message}}`),
 * or returns null when the failure did not come with one.
 */
export function backendErrorMessage(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }
  const body = error.error;
  if (typeof body === 'string' && body.trim()) {
    try {
      return backendErrorMessage(new HttpErrorResponse({error: JSON.parse(body)}));
    } catch (e) {
      return body;
    }
  }
  return body?.error?.message || body?.message || null;
}

/** Banner lines: the generic title followed by the backend message when there is one. */
export function errorBanner(title: string[], error: unknown): string[] {
  const message = backendErrorMessage(error);
  return message ? [title[0], message] : title;
}
